module.exports = __webpack_public_path__ + "img/device-mobile.1aab316f.svg";